import { useCallback, useEffect, useMemo, useState } from "react";
import { CalendarIcon } from "./svg/calendar.i";
import { ImageIcon } from "./svg/image.i";
import { TrimmingIcon } from "./svg/trimming.i";
import { Button, ButtonProps } from "../../../../ui/button/button";
import './trimming-select-button.scss';
import { IoInformationCircleOutline } from "react-icons/io5";

type Kind = 'image' | 'trimming' | 'date';

type Props = {
  kind: Kind,
  select?: boolean,
} & Omit<ButtonProps, 'icon'>;

export const TrimmingSelectButton = (props: Props) => {
  const {
    kind,
    select,
    ...defaultProps
  } = props;

  const Icon = useMemo(() => {
    switch(kind) {
      case 'date': return CalendarIcon;
      case 'image': return ImageIcon;
      case 'trimming': return TrimmingIcon;
    }
  }, [kind]);
  const theme = useMemo(() => {
    if (defaultProps.disabled) return 'disabled';
    return select ? 'on' : 'off';
  }, [select, defaultProps.disabled]);
  const onClickLink = useCallback(() => {
    window.open('https://cs.labonetwork.co.jp/sift-web/faq/product-system-specification/sift-051/?utm_medium=webapp&utm_campaign=helplink');
  }, []);
  return (
    <Button
      {...defaultProps}
      label={
        <>
          {defaultProps.label}
        </>
      }
      icon={<Icon theme={theme} />}
      className={
        `
          ${defaultProps.className}
          trimming_select_button
          type_${kind}
          ${select ? 'is_select' : ''}
        `
      }
    />
  )
}

// type TrimmingSelectButtonCoverProps = {
//   targetRects: DOMRect  | null,
//   theme: string,
// }

// export const TrimmingSelectButtonCover = (props: TrimmingSelectButtonCoverProps) => {
//   const {
//     targetRects,
//     theme,
//   } = props;
//   const [initStyle, setInitStyle] = useState<{left: string, width: string}>({ left: '', width: '' });
//   const style = useMemo(() => {
//     if (!targetRects) {
//       return initStyle;
//     }
//     return {
//       left: targetRects.left,
//       width: targetRects.width,
//     }
//   }, [targetRects, initStyle]);
//   useEffect(() => {
//     const items = document.getElementsByClassName('trimming_select_button');
//     const item = items.item(0);
//     const parent = item?.parentElement;
//     const itemsRects = item?.getClientRects().item(0);
//     const parentRects = parent?.getClientRects().item(0);
//     if (itemsRects && parentRects) {
//       setInitStyle({
//         left: `${itemsRects.left - parentRects.left}px`,
//         width: `${itemsRects.width}px`,
//       })
//     }
//   }, []);
//   return (
//     <div
//       className={`trimming_select_button__cover`}
//       style={style}
//     >
//       <div className={`print_cover_cnt ${theme}`} />
//     </div>
//   )
// }